import { v4 as uuid } from "uuid"

export const RISK_FAMILY_ENTITY = "riskFamily"
export const RISK_FAMILY_UNDEFINED_ID = "__undefined_risk_family__"

export interface RiskFamily {
  id: string
  code: string
  name: string
  isImageCustom: boolean

  //Keys
  AccountId: string | null

  //Calculated
  cSize: number
}

export const createEmptyRiskFamily = (overrides?: Partial<RiskFamily>): RiskFamily => ({
  id: uuid(),
  code: "",
  name: "",
  isImageCustom: false,
  AccountId: null,
  cSize: 0,
  ...overrides
})

export const createUndefinedRiskFamily = (): RiskFamily =>
  createEmptyRiskFamily({
    id: RISK_FAMILY_UNDEFINED_ID,
    code: "UNDEFINED",
    name: "Autres",
    //Cle non nulle volontairement : c'est ce qui fait passer le selecteur isActive a true,
    //sans quoi la page de cette famille afficherait "famille introuvable"
    AccountId: ""
  })
